<div class="searchBarFlightsMobile" [class.results]="isResultsPage">
  <div class="searchBarFlightsMobile__wrapper"
    [class.results]="isResultsPage"
    [class.alert]="isAlert">
    <ng-container *ngIf="!isAlert">
      <ng-container *ngTemplateOutlet="flightTypeSelection"></ng-container>
    </ng-container>
    <ng-template #exchangeHeader>
      <div class="exchange-type-selection">
        <h2>{{'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.EDIT_RESERVATION_TITLE' | transloco}}</h2>
        <p>{{'USER_HISTORY_MODULE.CHANGE_FLIGHTS_MODULE.EDIT_RESERVATION_DESCRIPTION' | transloco}}</p>
      </div>
    </ng-template>
    <div class="searchBarFlightsMobile__travel-destination-cont">
      <div class="searchBarFlightsMobile__travel-destination-cont__input">
        <app-search-place-input
          [searchType]="searchType"
          [isMobile]="true"
          [icon]="icons.StartPoint"
          [placeType]="departure"
          [place]="departurePlace"
          [samePlaceError]="samePlaceError"
          [showError]="isEmptyDeparturePlace"
          [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.FROM' | transloco"
          [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_ORIGIN_MOBILE' | transloco"
          [autoCompletePlaces]="autoCompletePlaces"
          [airports]="airports"
          [eventPath]="eventPath | async"
          (selectPlace)="selectPlace.emit($event)"
          [autofocus]="true"
          [isDisabled]="disabledPlace"
          [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
          [arrivalPlace]="arrivalPlace"
          [departurePlace]="departurePlace"
          (inputChanged)="placeInputChanged.emit($event)"
          (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
          (locationNotFoundEvent)="locationNotFoundEvent($event)"
          (popularSelected)="popularSelectedEvent($event)">
        </app-search-place-input>
      </div>
      <div class="searchBarFlightsMobile__swipe-locations">
        <app-ds-button-icon
          [buttonSize]="buttonIconSize"
          [icon]="arrowIcon"
          (clickEvent)="swapLocations()">
        </app-ds-button-icon>
      </div>
      <div class="searchBarFlightsMobile__travel-destination-cont__input">
        <app-search-place-input
          [searchType]="searchType"
          [showError]="isValidArrivalPlace"
          [isMobile]="true"
          [autofocus]="true"
          [icon]="icons.Location"
          [placeType]="arrival"
          [place]="arrivalPlace"
          [samePlaceError]="samePlaceError"
          [countryCode]="'SEARCH_MODULE.LOCATION_SEARCH.TO' | transloco"
          [countryName]="'SEARCH_MODULE.LOCATION_SEARCH.YOUR_DESTINATION_MOBILE' | transloco"
          [autoCompletePlaces]="autoCompletePlaces"
          [airports]="airports"
          [eventPath]="eventPath | async"
          [isDisabled]="isDisabled"
          [arrivalPlace]="arrivalPlace"
          [departurePlace]="departurePlace"
          (selectPlace)="selectPlace.emit($event)"
          [isLoadingAutocompletePlaces]="isLoadingAutocompletePlaces"
          (inputChanged)="placeInputChanged.emit($event)"
          (removeAutoCompletePlaces)="removeAutoCompletePlaces.emit()"
          (locationNotFoundEvent)="locationNotFoundEvent($event)"
          (popularSelected)="popularSelectedEvent($event)">
        </app-search-place-input>
      </div>
    </div>
    <ng-container *ngIf="isAlert">
      <ng-container *ngTemplateOutlet="flightTypeSelection; context: { isAlert: true }"></ng-container>
    </ng-container>
    <div class="travel-calendar-input-cont">
      <ng-container *ngIf="!isExchangeSearch; else exchangeCalendar">
        <app-search-bar-input
          [searchType]="searchType"
          [showError]="isEmptyDepartureDate"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
          [value]="departureDate | flightDate"
          [icon]="icons.Calendar"
          (isFocus)="showMobileCalendar(calendarField.departure)"
          [readOnly]="true"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
        <app-search-bar-input
          [searchType]="searchType"
          [showError]="isEmptyArrivalDate"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
          [label]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco" [value]="arrivalDate | flightDate"
          [icon]="icons.Calendar"
          [disabled]="isOneWayTrip"
          (isFocus)="showMobileCalendar(calendarField.arrival)"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
      </ng-container>
      <ng-template #exchangeCalendar>
        <app-search-bar-input
          *ngIf="showDepartureInput"
          [showError]="isEmptyDepartureDate"
          [label]="'DATE' | transloco"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_DEPARTURE' | transloco"
          [value]="departureDate | flightDate : true"
          [icon]="icons.Calendar"
          [disabled]="departureDateIsDisabled"
          (isFocus)="showMobileCalendar(calendarField.departure)"
          [class.left-input]="showArrivalInput"
          [class.full-input]="!showArrivalInput"
          [readOnly]="true"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
        <app-search-bar-input
          *ngIf="showArrivalInput"
          class="right-input"
          [showError]="isEmptyArrivalDate"
          [label]="'DATE' | transloco"
          [placeholder]="'SEARCH_MODULE.LOCATION_SEARCH.FLIGHT_RETURN' | transloco"
          [value]="arrivalDate | flightDate : true"
          [icon]="icons.Calendar"
          (isFocus)="showMobileCalendar(calendarField.arrival)"
          [class.full-input]="!showDepartureInput"
          [readOnly]="true"
          [isMobile]="true"
          [swapPlaceholder]="true">
        </app-search-bar-input>
      </ng-template>
    </div>
    <div class="travel-destination-cont" *ngIf="!isExchangeSearch">
      <app-search-bar-input
        (isFocus)="toggleFlightOption('PASSENGER_ARRANGEMENT')"
        [icon]="icons.ChevronFilledDown"
        [id]="'passenger-input'"
        [isPassengerField]="true"
        [label]="'SEARCH_MODULE.PASSENGERS_CLASS' | transloco"
        [readOnly]="true"
        [searchType]="searchType"
        [isMobile]="true"
        [value]="passengerArrangement | passengerInput : searchType : activeFlightClassText | titlecase">
      </app-search-bar-input>
    </div>
    <div *ngIf="showBaggageToggle" class="searchBarFlightsMobile__baggageToggle">
      <app-ds-typography 
        [text]="'SEARCH_MODULE.BAGGAGE_INCLUDE' | transloco"
        [size]="typographyFontSize.XXS"
        [fontFamily]="typographyFontFamily.SemiBold"
        [tag]="'p'"
        [color]="typographyColor.Primary">
      </app-ds-typography>
      <div class="searchBarFlightsMobile__baggageToggle-toggle">
        <app-ds-toggle
          [isActive]="!baggageIncluded"
          (toggleOnChange)="baggageIncludedChange($event)">
        </app-ds-toggle>
      </div>
    </div>
    <ng-container *ngIf="hasFlightsOffers">
      <div class="flight-offers">
        <div class="content-section">
          <div class="divider">
            <app-ds-divider></app-ds-divider>
          </div>
          <div class="header">
            <app-ds-typography
              [size]="fontSize.SM"
              [text]="'OFFERS_FLIGHT.UNBEATABLE_FLIGHT_MOBILE' | transloco"
              [color]="fontColor.Primary"
              [fontFamily]="fontFamily.SemiBold">
            </app-ds-typography>
          </div>
        </div>
        <div class="section-promo">
          <app-slide-flight-offers 
            [isMobile]="true"
            [flightOffers]="flightOffers"
            [departurePlace]="departurePlace"
            [arrivalPlace]="departurePlace"
            [source]="source"
            (editAction)="toggleEvent.emit()">
          </app-slide-flight-offers>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="searchBarFlightsMobile__searchBtn">
    <app-fixed-surface *ngIf="!isAlert"
      [boxShadow]="true">
      <div class="searchBarFlightsMobile__searchBtn__cont">
        <ng-container *ngIf="isValidFlexDates">
          <app-flex-dates-toggle
            [isActive]="isFlexDateCheck"
            (flexToggleOnChange)="toggleFlex($event)">
          </app-flex-dates-toggle>
        </ng-container>
        <app-ds-button
          [isLoading]="searching"
          [labels]="{ ButtonLabel: 'BUTTONS.SEARCH' | transloco }"
          (clickEvent)="searchFlights()">
        </app-ds-button>
      </div>
    </app-fixed-surface>
  </div>
</div>

<app-drop-down-view
  [defaultState]="showFlightOptionSelection"
  [title]="'SEARCH_MODULE.PASSENGERS_CLASS' | transloco"
  [showFooter]="true"
  (closeEvent)="toggleFlightOption()">
  <div class="searchBarFlightsMobile__passengerClassContent" content>
    <div class="searchBarFlightsMobile__passengerClassContent-passengers">
      <app-ds-typography
        [text]="'PASSENGERS' | transloco"
        [size]="typographyFontSize.XXS"
        [fontFamily]="typographyFontFamily.SemiBold"
        [color]="typographyColor.Primary">
      </app-ds-typography>
      <div class="searchBarFlightsMobile__passengerClassContent-passengers-option" *ngFor="let type of passengerArrangement">
        <div class="searchBarFlightsMobile__passengerClassContent-passengers-option-text">
          <app-ds-typography
            [tag]="'p'"
            [text]="'SEARCH_MODULE.PASSENGER_ARRANGEMENT.TYPE.' + type.id | transloco"
            [size]="typographyFontSize.XXS"
            [color]="typographyColor.Primary">
          </app-ds-typography>
          <app-ds-typography
            [tag]="'p'"
            [text]="'SEARCH_MODULE.PASSENGER_ARRANGEMENT.LABEL.' + type.id | transloco"
            [size]="typographyFontSize.XXXS"
            [color]="typographyColor.Secondary">
          </app-ds-typography>
        </div>
        <app-search-bar-operator
          [selector]="'search-flight-'"
          [type]="type.id"
          [initialQuantity]="type.quantity"
          [searchBy]="searchBy"
          [totalPassengers]="totalPassengers"
          [maxPassengers]="maxPassengers"
          [passengerArrangement]="passengerArrangement"
          (quantityEmmiter)="updatePassengerArrangement($event, type)">
        </app-search-bar-operator>
      </div>
    </div>
    <div class="searchBarFlightsMobile__passengerClassContent-divider">
      <app-ds-divider></app-ds-divider>
    </div>
    <div class="searchBarFlightsMobile__passengerClassContent-classes">
      <app-ds-typography
        [text]="'CLASS' | transloco"
        [size]="typographyFontSize.XXS"
        [fontFamily]="typographyFontFamily.SemiBold"
        [color]="typographyColor.Primary">
      </app-ds-typography>
    </div>
    <div class="searchBarFlightsMobile__passengerClassContent-classes-option" *ngFor="let flightClass of flightClassTypes">
      <app-ds-radio-button
        [align]="radioButtonAlign"
        [checked]="isActiveClass(flightClass)"
        [title]="{ Label: 'SEARCH_MODULE.FLIGHT_CLASSES.' + flightClass | transloco | titlecase }"
        (radioOnChecked)="selectFlightClass(flightClass)">
      </app-ds-radio-button>
    </div>
  </div>
  <div class="searchBarFlightsMobile__passengerClassButton" footer>
    <app-ds-button
      [labels]="{ ButtonLabel: 'BUTTONS.APPLY' | transloco }"
      (clickEvent)="toggleFlightOption()">
    </app-ds-button>
  </div>
</app-drop-down-view>

<ng-template #flightTypeSelection let-isAlert="isAlert">
  <div *ngIf="!isExchangeSearch; else exchangeHeader" class="searchBarFlightsMobile__radios" [class.alert]="isAlert">
    <div class="searchBarFlightsMobile__radio" *ngFor="let type of flightTypes">
      <app-ds-radio-button
        [checked]="isActiveFlightType(type)"
        [title]="{ Label: 'SEARCH_MODULE.FLIGHT_TYPE.' + type | transloco }"
        (radioOnChecked)="flightTypeSelected(type)">
      </app-ds-radio-button>
    </div>
  </div>
</ng-template>